<template>
  <div :class="{ 'center-screen' : !isMobile }">
    <div class="container">
      <br>
      <div class="panel validate-panel">
        <form class="validate-form" @submit.prevent="verify()">
          <div class="content">
            <div class="form-group">
              <div class="alert alert-success">
                Mailinize kod gönderildi ! Güvenliğiniz açısından mailinize gelen onay kodunu lütfen aşağıdaki kısıma yazınız
              </div>
            </div>
            <div class="form-group">
              <label>Mailinize Gelen Kodu Giriniz</label>
              <div class="otp-input">
                <input 
                  v-for="(value, index) in otp" 
                  :key="index" 
                  type="tel" 
                  maxlength="1" 
                  v-model="otp[index]" 
                  @input="handleInput($event, index)" 
                  @paste="handlePaste($event, index)"
                  ref="otpInput"
                  @keydown="moveToPrevious(index, $event)"
                />
              </div>
            </div>
            <div class="remaining">
              <span>Kalan Süre: <b>{{ timerCount }}</b></span>
            </div>
            <ButtonLoader class="primary block" :loader="btnLoading" :text="'Oturumu Doğrula'" />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['form'],
  data() {
    return {
      otp: ['', '', '', '', '', ''],
      timerCount: 180,
      code: '',
    };
  },
  created(){
    this.runTimer();
  },
  methods: {
    handleInput(event, index) {
      const value = event.target.value;
      if (value.length > 1) {
        this.otp[index] = value.charAt(0); 
      }

      if (value.length === 1 && index < this.otp.length - 1) {
        this.$refs.otpInput[index + 1].focus();
      }
      
      if (index === this.otp.length - 1 && this.otp[index].length === 1) {
        this.code = this.otp.join('');
        this.verify();
      }
  },

  handlePaste(event, index) {
    const pastedValue = event.clipboardData.getData('Text').slice(0, 6); 
    if (pastedValue.length === 6) {
      this.otp = pastedValue.split('');
    }

    
    this.$nextTick(() => {
      this.$refs.otpInput[index + pastedValue.length - 1].focus();
    });
  },

  moveToPrevious(index, event) {
    
    if (event.key === "Backspace" && index > 0 && !this.otp[index]) {
      this.$refs.otpInput[index - 1].focus();
    }
  },
    verify() {
      this.isLoading = true;
      axios.post('/auth/login/otp', { token: this.$route.query.token, code: this.code })
        .then((response) => {
          this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message });
          this.$store.dispatch('auth/autoLogin', { token: response.data.data.token });
        })
        .catch((err) => {
          
        })
        .finally(() => { 
          this.isLoading = false;
        });
    },
    runTimer() {
      if (this.timerCount > 0) {
        setTimeout(() => {
          this.timerCount--;
          this.runTimer();
        }, 1000);
      } else {
        window.location.reload();
      }
    },
  },
};
</script>

<style lang="scss">
.validate-panel{
    margin-bottom: 20px !important;
    margin: 0 auto;
    padding:20px;
    border-radius: 15px !important;
    max-width: 400px;
    .button{
        height: 45px !important;
        font-weight: 600 !important;
    }
    .validate-form {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .otp-input {
            display: flex;
            input {
                width: 100%;
                height: 50px;
                text-align: center;
                margin: 0 10px 0 00px;
                background: #ffffff1c !important;
                color: #fff !important;
                border: 2px solid #ffffff0d !important;
                font-size: 14px;
                padding: 0px !important;
                border-radius: 10px !important;
            }
        }
        .remaining{
            font-size: 14px;
            text-align: center;
            font-weight: bold;
            display: flex;
            margin: 10px 0;
            flex-direction: column;
            a{
                color: var(--client-c3);
            }
        }
        .button{
        }
    }
}
  </style>